<template>
  <div class="container">
    <Card shadow>
<!--      <div>-->
<!--        <Breadcrumb>-->
<!--          <BreadcrumbItem to="/">首页</BreadcrumbItem>-->
<!--          <BreadcrumbItem>在线支付</BreadcrumbItem>-->
<!--        </Breadcrumb>-->
<!--      </div>-->
      <SaleStep :current="current"></SaleStep>
      <!-- <Row class="pay-content pay-info">
        <Col span="21" offset="2" style="padding-bottom: 20px;border-bottom: solid #ddd 1px;">
          <span class="ticket-info">订单编号: {{$route.query.orderId}}</span>
          <span class="ticket-info">门票: {{orderInfo.displayName}}</span>
          <span class="ticket-info">游玩日期: {{orderInfo.playDate}}</span>
          <span class="ticket-info">数量: {{orderInfo.playCount}}张</span>
          <span class="ticket-info">应付金额:  <span class="ticket-price">{{orderInfo.totalPrice}}元</span></span>
        </Col>
      </Row> -->
      <div class="orderInfo-list">
        <div><span class="orderdetail">订单编号:</span><span>{{$route.query.orderId}}</span></div>
        <div><span class="orderdetail">门   票：</span><span>{{orderInfo.displayName}}</span></div>
        <div><span class="orderdetail">游玩日期：</span><span>{{orderInfo.playDate}}</span></div>
        <div><span class="orderdetail">游玩时段：</span><span>{{orderInfo.playPeriodName}}</span></div>
        <div><span class="orderdetail">数   量:</span><span>{{orderInfo.playCount}}张</span></div>
      </div>
      <Row class="pay-content pay-info">
        <Col span="8" offset="3" class="pay-style">
          <div><span class="total-price">订单总金额:</span><span class="total-price-num">{{orderInfo.totalPrice}}<span class="yuan">元</span></span></div>
          <div>
            <RadioGroup v-model="payType" vertical>
              <Radio label="WEIXIN">
                <span class="wxpay">
                  <img src="@/assets/weixin.png" alt="" width="16">
                  <span style="margin-left:5px">微信支付</span>
                </span>
              </Radio>
            </RadioGroup>
          </div>
        </Col>
        <Col span="12">
          <p style="margin-bottom: 10px;">
            距离二维码过期还剩
            <span style="font-size: 18px; font-weight: 600"> {{second}} </span>
            秒，过期后请
            <span style="font-size: 16px; color: red;">刷新</span>
            重新获取二维码。
          </p>
          <div class="qr-wrap">
            <div class="order-qr" id="qrCodeUrl" ref="qrCodeUrl"></div>
            <div class="qr-tip">请使用微信扫一扫, 扫描二维码支付</div>
            <img src="@/assets/payment.jpg" alt="" class="payment-img">
            <Button type="primary" @click="refreshQR" class="refresh-qr">刷新支付码</Button>
            <Spin size="large" fix v-if="spinShow"></Spin>
          </div>
        </Col>
      </Row>
      <Row class="pay-btn">
        <Col span="24" style="text-align: center;">
          <Button type="primary" class="next-btn" @click="handleSubmit">支付完成</Button>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
import Vue from 'vue'
import { httpAction } from '@/api/manage'
import SaleStep from '@/components/saleStep/Index'
import QRCode from 'qrcodejs2'
import common from '@/util/common'

export default {
  name: 'purchase-pay',
  components: {
    SaleStep
  },
  data () {
    return {
      current: 2,
      codeURL: '',
      orderInfo: {},
      orderStatusTime: null,
      spinOrderInfo: true,
      spinShow: true,
      payType: 'WEIXIN',
      second: 60,
      secondTime: null
    }
  },
  mounted () {
    this.getOrderinfo()
    this.getOrderDetail()
    this.orderStatusTime = setInterval(() => {
      this.getOrderDetail()
    }, 5000)

    this.secondTime = setInterval(() => {
      this.second -= 1
      if (this.second == 1) {
        this.getOrderinfo()
      }
    }, 1000)
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'purchase-individual') {
      this.$Modal.confirm({
        title: '您可能需要重新填写购票信息，是否要离开此页？',
        onOk: () => {
          next()
        },
        onCancel: () => {
          next(false)
        }
      })
    } else {
      next()
    }
  },
  destroyed () {
    clearInterval(this.orderStatusTime)
    clearInterval(this.secondTime)
  },
  methods: {
    refreshQR () {
      this.spinShow = true
      this.getOrderinfo()
    },
    handleSubmit () {
      this.getOrderDetail('to')
    },
    async getOrderinfo () {
      this.second = 60
      const orderId = this.$route.query.orderId ? this.$route.query.orderId : ''
      // const orderId = Vue.ls.get('orderId')
      const obj = { orderId }
      if (!orderId) { return false }
      httpAction(common.getUnifiedUrl(), 'post', obj).then(res => {
        if (res && res.status === '0') {
          this.codeURL = res.data.codeURL
          document.getElementById("qrCodeUrl").innerHTML = "";
          this.creatQrCode()
        } else {
          this.spinShow = false
        }
      })
    },
    async getOrderDetail (type) {
      const orderId = this.$route.query.orderId ? this.$route.query.orderId : ''
      // const orderId = Vue.ls.get('orderId')
      const obj = {
        id: orderId
        // orderSn: ''
      }
      if (!orderId) { return false }
      const res = await httpAction(common.getOrderDetailUrl(), 'post', obj)
      if (res && res.status === '0') {
        const data = res.data.itemList[0]
        this.orderInfo = {
          displayName: data.displayName,
          playCount: parseInt(res.data.totalPrice / data.price),
          playDate: data.playDate,
          playPeriodName: data.playPeriodName,
          price: data.price,
          totalPrice: res.data.totalPrice,
          status: res.data.status,
          statusName: res.data.statusName
        }
        if (this.spinOrderInfo) {
          this.spinOrderInfo = false
        }
        if (type === 'to') {
          this.$router.push({ path: '/purchase/end', query: { orderId } })
        } else {
          if (this.orderInfo.status !== '0') {
            this.$router.push({ path: '/purchase/end', query: { orderId } })
            // this.$router.push('/purchase/end')
          }
        }
      }
    },
    creatQrCode () {
      const url = this.codeURL
      // eslint-disable-next-line no-unused-vars
      const qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: url,
        width: 220,
        height: 220,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      this.spinShow = false
    }
  }
}
</script>

<style scoped lang="less">
  .container{
    margin-top:10px
  }
  .ticket-title{
    color: @pay-title;
    margin-bottom: 16px;
  }
  .ticket-info{
    font-size: 16px;
    margin-right: 32px;
  }
  .ticket-price{
    color: @pay-price;
    font-size: 28px;
    font-weight: 600;
  }
  .order-qr{
    margin-bottom: 20px;
    display: flex;
    z-index: 2;
  }
  .next-btn{
    padding: 0 120px;
    height: 40px;
  }
  .pay-content{
    margin: 30px 0 30px;
  }
  .pay-btn{
    margin-bottom: 40px;
  }
  .qr-wrap{
    width: 260px;
    padding: 20px 20px 36px;
    border: solid #ddd 1px;
    position: relative;
    min-height: 298px;
  }
  .qr-tip{
    background: #ddd;
    text-align: center;
    line-height: 36px;
    font-size: 12px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .payment-img{
    position: absolute;
    left: calc(100% + 1px);
    top: 0;
    height: 298px;
    width: 252px;
  }
  .pay-info{
    display: flex;
    flex-direction: row;
    /*align-items: center;*/
  }
  .refresh-qr{
    position: absolute;
    left: 100%;
    top: 0;
  }
  .orderInfo-list{
    display: flex;
    flex-direction: column;
    height:200px;
    border:1px solid #ddd;
    border-radius: 10px;
    font-size: 18px;
    margin:80px 80px 0px;
    padding-left: 50px;
    line-height: 40px;
  }
  .pay-style{
    padding-top:30px;
    line-height: 50px;
  }
  .total-price{
    font-size: 18px;
    font-weight: 600;
  }
  .total-price-num{
    margin-left: 20px;
    font-size: 24px;
    color:@common
  }
  .yuan{
    font-size: 12px;
  }
  .wxpay{
   margin-left: 20px;
   font-size: 16px;
  }
  .orderdetail{
    display:inline-block;
    width:120px;
  }
</style>
